import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "AnnualQuota/";

const getAnnualQuotaById = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetAnnualQuotaById?id=' + id, constants.REQUIRE_INTERCEPTORS);

const getAnnualQuotas = async () => await axiosInstance.get(ENDPOINTORIGIN + 'GetAnnualQuotas', constants.REQUIRE_INTERCEPTORS);

const saveAnnualQuota = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveAnnualQuota', model, constants.REQUIRE_INTERCEPTORS);

const deleteAnnualQuota = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'DeleteAnnualQuota?id=' + id, constants.REQUIRE_INTERCEPTORS);

export {
    getAnnualQuotaById,
    getAnnualQuotas,
    saveAnnualQuota,
    deleteAnnualQuota
}